<template>
  <div>
    <div>
      <h2>Generate players</h2>

      <p class="mb-2">
        For feature testing purposes, you can ask server to generate multiple fake players.
      </p>

      <p class="alert alert-warning mb-2">
        NOTE: This feature only available when property IS_DEV is enabled.
      </p>

      <p class="alert alert-primary">
        NOTE: Generation is done in background, you will not see progress on this page. Check insider log for
        completion.
      </p>

      <form @submit.prevent="generatePlayersWithConfirmation">
        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="amount">Players to generate</label>
          <div class="col-md-8">
            <input v-model.number="amount" id="amount" class="form-control" type="number" min="0">
          </div>
        </div>

        <hr>

        <b-button class="offset-md-4" type="submit" variant="primary">Generate</b-button>
      </form>
    </div>
  </div>
</template>

<script>
import {confirmAction} from '../../service/confirm';
import notifier from '../../notifier';
import {HTTP} from '../../http-common';

export default {
  name: "DevGeneratePlayers",

  data() {
    return {
      amount: 100,
    }
  },

  methods: {
    generatePlayersWithConfirmation() {
      notifier.deleteSenderNotifications(this);

      this.confirmPlayersGeneration(() => {
        this.generatePlayers();
      });
    },

    confirmPlayersGeneration(onConfirmed) {
      confirmAction(
          this,
          `Are you sure you want to generate ${this.amount} players?`,
          'Generate',
          onConfirmed,
      );
    },

    generatePlayers() {
      const data = new FormData();
      data.set('amount', this.amount);

      HTTP.post('/river_rumble/generate_players', data)
          .then(response => {
            const result = response.data.result;

            const RESULT_SUCCESS = 1;
            if (result.code === RESULT_SUCCESS) {
              notifier.showSuccessAfterTransition('Players generation started.');
              return;
            }

            notifier.showError(result.message, {sender: this});
          })
          .catch(e => {
            notifier.showError(e, {sender: this});
          });
    },
  }
}
</script>

